// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__2CPI_","imageUploader":"EGiftCard_imageUploader__2D4wO"};